import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from 'src/app/services/digisubservices.service';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-bookstoresendmessage',
  templateUrl: './bookstoresendmessage.component.html',
  styleUrls: ['./bookstoresendmessage.component.scss'],
})
export class BookstoresendmessageComponent implements OnInit {

  sendmsgform: FormGroup;
  book: any;
  books: any[] = [];
  isDone: boolean = false;

  // Separate controls for courier so we can save/load independently
  courierNameCtrl = new FormControl('');
  courierDateCtrl = new FormControl('');

  private STORAGE_KEY      = 'removedBookIds';
  private COURIER_KEY_PREFIX = 'courier_'; // key = courier_<bookId>

  constructor(
    private fb: FormBuilder,
    private service: DigisubservicesService,
    private dialogRef: MatDialogRef<BookstoresendmessageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.sendmsgform = this.fb.group({
      bsname:      [''],
      repname:     [''],
      orderno:     [''],
      orderdate:   [''],
      billno:      [''],
      billdate:    [''],
      receiptno:   [''],
      receiptdate: [''],
      address2:     [''],
      mobno:       [''],
      couriername: [''],
      courierdate: [''],
      courierwebsite: [''],
    });
  }

  ngOnInit(): void {
    debugger
    this.book = this.data?.book;

    const removedIds = this.getRemovedIds();

    if (removedIds.includes(Number(this.book?.id))) {
      this.isDone = true;
      return;
    }

    const fmt = (date: any) => {
      try {
        return date ? formatDate(date, 'dd-MM-yyyy', 'en-IN') : '';
      } catch {
        return '';
      }
    };

    this.sendmsgform.patchValue({
      bsname:      this.book?.custname,
      repname:     this.book?.rep,
      orderno:     this.book?.order_no,
      orderdate:   fmt(this.book?.bookingdate),
      billno:      this.book?.invoice_no,
      billdate:    fmt(this.book?.invoice_date),
      receiptno:   this.book?.rcptno,
      receiptdate: fmt(this.book?.rcptdate),
      address2:     `${this.book?.address || ''} ${this.book?.taluka || ''}, ${this.book?.district || ''}, ${this.book?.state || ''}, ${this.book?.country || ''} - ${this.book?.pincode || ''}`,
      mobno:       this.book?.mobile_no,
    });

    // ── Load saved courier data for this book entry ──
    this.loadCourierFromStorage();

    // ── Keep form fields in sync with standalone controls ──
    this.courierNameCtrl.valueChanges.subscribe(val => {
      this.sendmsgform.patchValue({ couriername: val });
      this.saveCourierToStorage();
    });

    this.courierDateCtrl.valueChanges.subscribe(val => {
      this.sendmsgform.patchValue({ courierdate: val });
      this.saveCourierToStorage();
    });

    if (this.book?.id) {
      this.service.getBooks(this.book.id).subscribe((res: any[]) => {
        this.books = res;
      });
    }
  }

  // ── Courier localStorage helpers ──

  private courierStorageKey(): string {
    return `${this.COURIER_KEY_PREFIX}${this.book?.id}`;
  }

  saveCourierToStorage(): void {
    if (!this.book?.id) return;
    const payload = {
      couriername: this.courierNameCtrl.value || '',
      courierdate: this.courierDateCtrl.value || '',
    };
    localStorage.setItem(this.courierStorageKey(), JSON.stringify(payload));
  }

  private loadCourierFromStorage(): void {
    if (!this.book?.id) return;
    const raw = localStorage.getItem(this.courierStorageKey());
    if (!raw) return;

    try {
      const saved = JSON.parse(raw);
      this.courierNameCtrl.setValue(saved.couriername || '', { emitEvent: false });
      this.courierDateCtrl.setValue(saved.courierdate || '', { emitEvent: false });
      this.sendmsgform.patchValue({
        couriername: saved.couriername || '',
        courierdate: saved.courierdate || '',
      });
    } catch {
      // ignore corrupt data
    }
  }

  // ── Done / removed ──

  markAsDone(): void {
    debugger

  if (!confirm('हे काम पूर्ण झाले आहे का?')) {
    return;
  }

  const bookId = Number(this.book?.id);

  this.service.saveRemovedBookIds([bookId]).subscribe({
    next: () => {

      this.isDone = true;

      setTimeout(() => {
        this.dialogRef.close({
          action: 'done',
          bookId: bookId
        });
      }, 1000);

    },
    error: (err) => {
      console.error(err);
      alert('Server error. Status not updated.');
    }
  });
}

  private getRemovedIds(): number[] {
    return JSON.parse(localStorage.getItem(this.STORAGE_KEY) || '[]');
  }

  // ── Print ──

 print(): void {

  const f = this.sendmsgform.value;
  const b = this.book;

  if (!f || !b) {
    alert('Nothing to print!');
    return;
  }

  const printWindow = window.open('', '_blank', 'width=900,height=1200');

  if (!printWindow) {
    alert('Please allow popups to print');
    return;
  }

  const fmt = (date: any) => {
    try {
      return date ? formatDate(date, 'dd-MM-yyyy', 'en-IN') : '';
    } catch {
      return date || '';
    }
  };

  const bookRows = (this.books || [])
    .map((book: any, i: number) => `
      <div class="book-row">
        <div class="b-name">${i + 1}) ${book.bookname || ''}</div>
        <div class="b-copies">${book.bookcopies || ''}</div>
      </div>
    `)
    .join('');

  const courierRow =
    (f.couriername || f.courierdate)
      ? `
      <div class="form-row" style="margin-top:12px;">
        <div class="label">कुरियर :</div>
        <div class="value">${f.couriername || ''}</div>

        <div class="label" style="min-width:70px;">दिनांक :</div>
        <div class="value">${f.courierdate || ''}</div>
      </div>
    `
      : '';

  printWindow.document.open();

  printWindow.document.write(`
<!DOCTYPE html>
<html lang="mr">
<head>
<meta charset="UTF-8">
<title>Receipt Print</title>

<style>

@page {
  size: A4;
  margin: 10mm;
}

body {
  font-family: Arial, sans-serif;
  font-size: 11pt;
  margin: 0;
  color: #000;
}

* {
  box-sizing: border-box;
}

.receipt {
  width: 100%;
  border: 2px solid #000;
  padding: 10px;
}

.row {
  display: flex;
  width: 100%;
}

.col-left {
  width: 50%;
  padding-right: 10px;
  border-right: 2px dotted #000;
}

.col-right {
  width: 50%;
  padding-left: 10px;
}

.form-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
  gap: 8px;
}

.label {
  font-weight: bold;
  min-width: 100px;
  white-space: nowrap;
}

.value {
  flex: 1;
  word-break: break-word;
}

.book-header {
  display: flex;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.b-name {
  flex: 1;
}

.b-copies {
  width: 60px;
  text-align: right;
}

.book-row {
  display: flex;
  margin-bottom: 3px;
}

.delivery {
  text-align: right;
  font-weight: bold;
  font-size: 12pt;
  margin-bottom: 12px;
}

.sender {
  display: flex;
  margin-top: 20px;
}

.sender img {
  width: 80px;
}

.sender-info {
  font-size: 10pt;
  line-height: 1.5;
  margin-left: 10px;
}

</style>
</head>

<body>

<div class="receipt">

  <div class="row">

    <!-- LEFT -->
    <div class="col-left">

      <div class="form-row">
        <div class="label">बुक सेलर :</div>
        <div class="value">${f.bsname || ''}</div>
      </div>

      <div class="form-row">
        <div class="label">प्रतिनिधी :</div>
        <div class="value">${f.repname || ''}</div>
      </div>

      <div class="form-row">
        <div class="label">ऑर्डर नं :</div>
        <div class="value">${f.orderno || ''}</div>
      </div>

      <div class="form-row">
        <div class="label">दिनांक :</div>
        <div class="value">${fmt(b.bookingdate)}</div>
      </div>

      <div class="form-row">
        <div class="label">बिल नं :</div>
        <div class="value">${f.billno || ''}</div>
      </div>

      <div class="form-row">
        <div class="label">बिल दिनांक :</div>
        <div class="value">${fmt(b.invoice_date)}</div>
      </div>

      <div class="form-row">
        <div class="label">पावती नं :</div>
        <div class="value">${f.receiptno || ''}</div>
      </div>

      <div class="form-row">
        <div class="label">पावती दिनांक :</div>
        <div class="value">${fmt(b.rcptdate)}</div>
      </div>

      <div class="book-header">
        <div class="b-name">पुस्तक</div>
        <div class="b-copies">प्रती</div>
      </div>

      ${bookRows}

      ${courierRow}

    </div>

    <!-- RIGHT -->
    <div class="col-right">

      <div class="delivery">
        ${b.deliverymode || 'By Hand'}
      </div>

      <div class="form-row">
        <div class="label">प्रति,</div>
      </div>

      <div class="form-row">
        <div class="label">बुक सेलर :</div>
        <div class="value">${f.bsname || ''}</div>
      </div>

      <div class="form-row">
        <div class="label">पत्ता :</div>
        <div class="value">${f.address2 || ''}</div>
      </div>

      <div class="form-row">
        <div class="label">मोबाईल :</div>
        <div class="value">${f.mobno || ''}</div>
      </div>

      <div class="sender">

        <img src="../../../assets/img/brand/book.png" alt="logo">

        <div class="sender-info">
          <strong>प्रेषक,</strong><br>
          हिंदुस्थान प्रकाशन संस्था - पुस्तक विभाग<br>
          116-119,पहिला मजला, शिल्पीन सेंटर, 40, गं. द. आंबेकर मार्ग,<br>
           वडाला मुंबई - 400031<br>
          दूरध्वनी: ९९६७५७०५३१
        </div>

      </div>

    </div>

  </div>

</div>

</body>
</html>
`);

  printWindow.document.close();

  printWindow.onload = () => {
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();

      setTimeout(() => {
        printWindow.close();
      }, 300);

    }, 500);
  };
}
}